export { default } from './UserMgmtInfoForm';
